import {
    FILTER_WIDGETS_TEXT,
    GET_PACK_WIDGETS,
    RESET_PACK_WIDGETS,
    POST_PACK_WIDGET,
    DELETE_PACK_WIDGET
} from './constants';

const packsDefault = {
    filterWidgetsText: '',
    editPackId: '',
    editPackWidgets: [],
    isEditPackWidgets: false,
    resetPackWidgets: 0
};

export default (packs = packsDefault, { type, payload }) => {
    switch (type) {
        case FILTER_WIDGETS_TEXT:
            return {
                ...packs,
                filterWidgetsText: payload.text
            };
        case GET_PACK_WIDGETS:
            return {
                ...packs,
                editPackId: payload.packId,
                editPackWidgets: payload.widgets
            };
        case RESET_PACK_WIDGETS:
            return {
                ...packs,
                isEditPackWidgets: false,
                resetPackWidgets: Math.random(Date.now)
            };
        case POST_PACK_WIDGET:
            return {
                ...packs,
                isEditPackWidgets: true,
                editPackWidgets: [...packs.editPackWidgets, payload.widgetId]
            };
        case DELETE_PACK_WIDGET:
            return {
                ...packs,
                isEditPackWidgets: true,
                editPackWidgets: packs.editPackWidgets.filter(widgetId => widgetId !== payload.widgetId)
            };
        default:
            return packs;
    }
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/packs/reducer.js
 **/